var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.item},[(_vm.title)?_c('div',{class:[_vm.$style.title]},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }